import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const replacementFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.replacement, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
